import { useEffect, useState } from 'react';
import client from '../contentfulClient';
import LeftPanel from '../components/LeftPanel';
import RightPanel from '../components/RightPanel';
import Footer from '../components/Footer';

const HomePage = () => {
  const [homepage, setHomepage] = useState(null);

  useEffect(() => {
    client
      .getEntries({ content_type: 'homepage' })
      .then((response) => {
        setHomepage(response.items[0]?.fields);
      })
      .catch(console.error);
  }, []);

  if (!homepage)
    return (
      <div role="status" aria-live="polite">
        Loading...
      </div>
    );

  return (
    <div className="min-h-screen flex flex-col font-sans text-black">
      <main className="flex flex-col md:flex-row flex-grow bg-white min-h-screen">
        <LeftPanel />
        <RightPanel homepage={homepage} />
      </main>
      <Footer homepage={homepage} />
    </div>
  );
};

export default HomePage;
